import { render, staticRenderFns } from "./addMobileMoneyAccountForm.vue?vue&type=template&id=56100b5b"
import script from "./addMobileMoneyAccountForm.vue?vue&type=script&lang=js"
export * from "./addMobileMoneyAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports